export const mapNameIdToSelectOption = (array?: { id: number; name: string }[]) => {
  return (array || []).map(({ id, name }) => ({
    label: name,
    value: id,
  }));
};
